// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"IntroVideo_modalContent__1AvcP","modalBody":"IntroVideo_modalBody__2x0CV","videoPlayer":"IntroVideo_videoPlayer__1BaEu"};